import { EvaluatorFactory, AsyncEvaluatorFactory } from './Factory.js'

/**
 * This will create an Async/Sync EvaluatorFactroy that by default will use 
 * AsyncEvaluator plugins registered at 'AsyncConditionEvaluator', followed
 * by SynchEvaluator plugins registered at 'ConditionEvaluator'. These
 * factory can be replaced by supplying an options object containing 
 * { asyncFactory, syncFactory }
 * 
 * This is the default factory used for the AsyncEvaluator, as it levereges
 * synchronous evaluators where async versions are not available.
 */
export default class AsyncSyncEvaluatorFactory {
  constructor( options ) {
    this.asyncFactory = options?.asyncFactory || AsyncEvaluatorFactory
    this.syncFactory = options?.syncFactory || EvaluatorFactory

  }

  create( ...rest ) {
    return this.asyncFactory.create( ...rest ) || this.syncFactory.create( ...rest )
  }
}
